var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExploreJobsMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90.376,
    height: 97.337,
    viewBox: "0 0 90.376 97.337",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1679",
    "data-name": "Rectangle 1679",
    width: 77.759,
    height: 97.337,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1646",
    "data-name": "Rectangle 1646",
    width: 17.017,
    height: 4.246,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1662",
    "data-name": "Rectangle 1662",
    width: 13.741,
    height: 4.245,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1677",
    "data-name": "Rectangle 1677",
    width: 24.452,
    height: 6.101,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1678",
    "data-name": "Rectangle 1678",
    width: 3.633,
    height: 2.71,
    fill: "#b2caff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1706",
    "data-name": "Rectangle 1706",
    width: 76.513,
    height: 92.163,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1705",
    "data-name": "Rectangle 1705",
    width: 76.513,
    height: 91.568,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1702",
    "data-name": "Rectangle 1702",
    width: 21.393,
    height: 18.26,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1701",
    "data-name": "Rectangle 1701",
    width: 21.391,
    height: 18.26,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1704",
    "data-name": "Rectangle 1704",
    width: 23.544,
    height: 20.483,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9397",
    "data-name": "Group 9397",
    transform: "translate(-592.541 -297.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10359",
    "data-name": "Path 10359",
    d: "M77.759,347.617c0,1.658-17.407,3-38.879,3S0,349.274,0,347.617s17.407-3,38.879-3,38.879,1.344,38.879,3",
    transform: "translate(605.158 44.405)",
    fill: "#7586ec",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9327",
    "data-name": "Group 9327",
    transform: "translate(605.158 297.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9326",
    "data-name": "Group 9326",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10360",
    "data-name": "Path 10360",
    d: "M140.964,210.006H124.775a.414.414,0,0,1-.414-.414V202.84a.414.414,0,0,1,.414-.414h16.189a.414.414,0,0,1,.414.414v6.752a.414.414,0,0,1-.414.414",
    transform: "translate(-91.401 -148.776)",
    fill: "#bbd5fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9229",
    "data-name": "Group 9229",
    transform: "translate(32.961 53.65)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9228",
    "data-name": "Group 9228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9227",
    "data-name": "Group 9227",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10362",
    "data-name": "Path 10362",
    d: "M140.966,202.427H124.778a.413.413,0,0,0-.414.414v2.166l8.429,1.658a.381.381,0,0,0,.157,0l8.431-1.658v-2.166a.414.414,0,0,0-.415-.414",
    transform: "translate(-124.364 -202.427)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10363",
    "data-name": "Path 10363",
    d: "M140.356,186.081h-4.944v-.83a1.3,1.3,0,0,0-1.294-1.294H129.7a1.3,1.3,0,0,0-1.293,1.294v.83h-4.944a.408.408,0,0,0-.408.408v4.083a.408.408,0,0,0,.329.4l8.447,1.661a.4.4,0,0,0,.157,0l8.447-1.661a.408.408,0,0,0,.329-.4V186.49a.408.408,0,0,0-.408-.408m-10.966-.83a.315.315,0,0,1,.311-.311h4.417a.315.315,0,0,1,.311.311v.83H129.39Z",
    transform: "translate(-90.441 -135.203)",
    fill: "#bbd5fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10365",
    "data-name": "Path 10365",
    d: "M153.835,214.381h-1.746a.392.392,0,0,1-.391-.391v-1.1a.392.392,0,0,1,.391-.391h1.746a.393.393,0,0,1,.391.391v1.1a.393.393,0,0,1-.391.391",
    transform: "translate(-111.493 -156.176)",
    fill: "#a2b0e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10374",
    "data-name": "Path 10374",
    d: "M45.8,210.006H29.609a.414.414,0,0,1-.414-.414V202.84a.414.414,0,0,1,.414-.414H45.8a.414.414,0,0,1,.414.414v6.752a.414.414,0,0,1-.414.414",
    transform: "translate(-21.457 -148.776)",
    fill: "#bbd5fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9253",
    "data-name": "Group 9253",
    transform: "translate(7.739 53.65)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9252",
    "data-name": "Group 9252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9251",
    "data-name": "Group 9251",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10376",
    "data-name": "Path 10376",
    d: "M45.8,202.427H29.612a.413.413,0,0,0-.414.414v2.166l8.429,1.658a.381.381,0,0,0,.157,0l8.431-1.658v-2.166a.414.414,0,0,0-.415-.414",
    transform: "translate(-29.198 -202.427)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10377",
    "data-name": "Path 10377",
    d: "M45.191,186.081H40.247v-.83a1.3,1.3,0,0,0-1.293-1.294H34.536a1.3,1.3,0,0,0-1.293,1.294v.83H28.3a.408.408,0,0,0-.408.408v4.083a.408.408,0,0,0,.329.4l8.446,1.661a.4.4,0,0,0,.158,0l8.447-1.661a.408.408,0,0,0,.329-.4V186.49a.408.408,0,0,0-.408-.408m-10.966-.83a.315.315,0,0,1,.311-.311h4.417a.315.315,0,0,1,.311.311v.83H34.225Z",
    transform: "translate(-20.498 -135.203)",
    fill: "#bbd5fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10388",
    "data-name": "Path 10388",
    d: "M43.677,118.029H29.605a.415.415,0,0,1-.414-.414v-6.751a.4.4,0,0,1,.034-.163.368.368,0,0,1,.037-.069.418.418,0,0,1,.052-.062.414.414,0,0,1,.293-.121H42.934a17.45,17.45,0,0,0-.109,2.789c.005.15.012.3.025.451.017.276.039.557.072.836a17.776,17.776,0,0,0,.755,3.5",
    transform: "translate(-21.454 -81.177)",
    fill: "#bbd5fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9277",
    "data-name": "Group 9277",
    transform: "translate(7.739 29.273)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9276",
    "data-name": "Group 9276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9275",
    "data-name": "Group 9275",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10390",
    "data-name": "Path 10390",
    d: "M42.941,110.45a17.449,17.449,0,0,0-.108,2.789c0,.15.012.3.025.451l-3.886.762-1.186.234a.346.346,0,0,1-.158,0l-1.183-.232L29.2,113.029v-2.167a.435.435,0,0,1,.032-.16.376.376,0,0,1,.037-.069.418.418,0,0,1,.052-.062.414.414,0,0,1,.293-.121Z",
    transform: "translate(-29.2 -110.45)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10391",
    "data-name": "Path 10391",
    d: "M42.532,94.107H40.247v-.831a1.3,1.3,0,0,0-1.294-1.292H34.536a1.294,1.294,0,0,0-1.295,1.292v.831H28.3a.408.408,0,0,0-.409.407V98.6a.411.411,0,0,0,.33.4l.015,0h0l7.244,1.428,1.183.232a.426.426,0,0,0,.158,0l1.186-.234,3.861-.76a17.717,17.717,0,0,1,.663-5.56m-8.309-.831a.316.316,0,0,1,.313-.311h4.416a.314.314,0,0,1,.311.311v.831h-5.04Z",
    transform: "translate(-20.497 -67.605)",
    fill: "#bbd5fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10393",
    "data-name": "Path 10393",
    d: "M58.669,122.4H56.923a.392.392,0,0,1-.391-.391v-1.1a.392.392,0,0,1,.391-.391h1.746a.392.392,0,0,1,.391.391v1.1a.393.393,0,0,1-.391.391",
    transform: "translate(-41.549 -88.575)",
    fill: "#a2b0e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10395",
    "data-name": "Path 10395",
    d: "M219.94,210.006h16.189a.414.414,0,0,0,.414-.414V202.84a.414.414,0,0,0-.414-.414H219.94a.414.414,0,0,0-.414.414v6.752a.414.414,0,0,0,.414.414",
    transform: "translate(-161.344 -148.776)",
    fill: "#bbd5fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9289",
    "data-name": "Group 9289",
    transform: "translate(58.182 53.65)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9288",
    "data-name": "Group 9288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9287",
    "data-name": "Group 9287",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10397",
    "data-name": "Path 10397",
    d: "M219.94,202.427h16.188a.413.413,0,0,1,.414.414v2.166l-8.43,1.658a.38.38,0,0,1-.157,0l-8.431-1.658v-2.166a.414.414,0,0,1,.415-.414",
    transform: "translate(-219.525 -202.427)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10398",
    "data-name": "Path 10398",
    d: "M218.629,186.081h4.944v-.83a1.3,1.3,0,0,1,1.293-1.294h4.417a1.3,1.3,0,0,1,1.293,1.294v.83h4.945a.408.408,0,0,1,.408.408v4.083a.408.408,0,0,1-.329.4l-8.446,1.661a.4.4,0,0,1-.158,0l-8.447-1.661a.408.408,0,0,1-.329-.4V186.49a.408.408,0,0,1,.408-.408m10.966-.83a.315.315,0,0,0-.311-.311h-4.417a.315.315,0,0,0-.311.311v.83H229.6Z",
    transform: "translate(-160.385 -135.203)",
    fill: "#bbd5fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10400",
    "data-name": "Path 10400",
    d: "M247.248,214.381h1.746a.392.392,0,0,0,.391-.391v-1.1a.392.392,0,0,0-.391-.391h-1.746a.393.393,0,0,0-.391.391v1.1a.393.393,0,0,0,.391.391",
    transform: "translate(-181.431 -156.176)",
    fill: "#a2b0e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10409",
    "data-name": "Path 10409",
    d: "M229.083,118.029h14.071a.415.415,0,0,0,.414-.414v-6.751a.4.4,0,0,0-.034-.163.365.365,0,0,0-.037-.069.418.418,0,0,0-.052-.062.414.414,0,0,0-.293-.121H229.825a17.452,17.452,0,0,1,.109,2.789c-.005.15-.012.3-.025.451-.018.276-.039.557-.072.836a17.777,17.777,0,0,1-.755,3.5",
    transform: "translate(-168.368 -81.177)",
    fill: "#bbd5fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9313",
    "data-name": "Group 9313",
    transform: "translate(61.457 29.273)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9312",
    "data-name": "Group 9312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9311",
    "data-name": "Group 9311",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10411",
    "data-name": "Path 10411",
    d: "M231.884,110.45a17.451,17.451,0,0,1,.108,2.789c0,.15-.012.3-.025.451l3.886.762,1.186.234a.346.346,0,0,0,.158,0l1.183-.232,7.244-1.425v-2.167a.429.429,0,0,0-.032-.16.357.357,0,0,0-.037-.069.42.42,0,0,0-.052-.062.414.414,0,0,0-.293-.121Z",
    transform: "translate(-231.884 -110.45)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10412",
    "data-name": "Path 10412",
    d: "M229.791,94.107h2.286v-.831a1.3,1.3,0,0,1,1.294-1.292h4.416a1.294,1.294,0,0,1,1.294,1.292v.831h4.944a.408.408,0,0,1,.409.407V98.6a.411.411,0,0,1-.33.4l-.015,0h0l-7.244,1.428-1.183.232a.426.426,0,0,1-.158,0l-1.186-.234-3.861-.76a17.716,17.716,0,0,0-.663-5.56m8.309-.831a.316.316,0,0,0-.313-.311h-4.416a.314.314,0,0,0-.311.311v.831h5.04Z",
    transform: "translate(-168.888 -67.605)",
    fill: "#bbd5fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10414",
    "data-name": "Path 10414",
    d: "M247.248,122.4h1.746a.392.392,0,0,0,.391-.391v-1.1a.392.392,0,0,0-.391-.391h-1.746a.392.392,0,0,0-.391.391v1.1a.393.393,0,0,0,.391.391",
    transform: "translate(-181.431 -88.575)",
    fill: "#a2b0e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10416",
    "data-name": "Path 10416",
    d: "M137.424,115.132H114.162a.6.6,0,0,1-.595-.595v-9.7a.6.6,0,0,1,.595-.6h23.263a.6.6,0,0,1,.595.6v9.7a.6.6,0,0,1-.595.595",
    transform: "translate(-83.468 -76.613)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10417",
    "data-name": "Path 10417",
    d: "M149.036,83.122h-6.347a1.818,1.818,0,0,1-1.815-1.815V79.684a1.818,1.818,0,0,1,1.815-1.815h6.347a1.817,1.817,0,0,1,1.815,1.815v1.622a1.817,1.817,0,0,1-1.815,1.815m-6.347-3.928a.491.491,0,0,0-.49.49v1.622a.491.491,0,0,0,.49.49h6.347a.491.491,0,0,0,.49-.49V79.684a.491.491,0,0,0-.49-.49Z",
    transform: "translate(-103.537 -57.231)",
    fill: "#b2caff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9322",
    "data-name": "Group 9322",
    transform: "translate(30.101 27.628)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9321",
    "data-name": "Group 9321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9320",
    "data-name": "Group 9320",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10418",
    "data-name": "Path 10418",
    d: "M137.427,104.243H114.166a.593.593,0,0,0-.594.594v3.113l12.112,2.382a.557.557,0,0,0,.226,0l12.115-2.382v-3.113a.6.6,0,0,0-.6-.594",
    transform: "translate(-113.572 -104.243)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10419",
    "data-name": "Path 10419",
    d: "M136.664,96.246l-12.137,2.387a.592.592,0,0,1-.227,0l-12.137-2.387a.587.587,0,0,1-.473-.575V89.8a.587.587,0,0,1,.587-.587h24.274a.587.587,0,0,1,.587.587v5.867a.586.586,0,0,1-.473.575",
    transform: "translate(-82.089 -65.571)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10420",
    "data-name": "Path 10420",
    d: "M155.918,121.42h-2.509a.564.564,0,0,1-.562-.562v-1.585a.564.564,0,0,1,.562-.562h2.509a.564.564,0,0,1,.562.562v1.585a.564.564,0,0,1-.562.562",
    transform: "translate(-112.337 -87.248)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9325",
    "data-name": "Group 9325",
    transform: "translate(40.51 31.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9324",
    "data-name": "Group 9324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9323",
    "data-name": "Group 9323",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10421",
    "data-name": "Path 10421",
    d: "M155.918,121.42h-2.509a.564.564,0,0,1-.562-.562v-1.585a.564.564,0,0,1,.562-.562h2.509a.564.564,0,0,1,.562.562v1.585a.564.564,0,0,1-.562.562",
    transform: "translate(-152.847 -118.71)",
    fill: "#b2caff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10536",
    "data-name": "Path 10536",
    d: "M153.835,214.381h-1.746a.392.392,0,0,1-.391-.391v-1.1a.392.392,0,0,1,.391-.391h1.746a.393.393,0,0,1,.391.391v1.1a.393.393,0,0,1-.391.391",
    transform: "translate(-136.717 -156.178)",
    fill: "#a2b0e1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9394",
    "data-name": "Group 9394",
    transform: "translate(592.541 301.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9393",
    "data-name": "Group 9393",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9423",
    "data-name": "Group 9423",
    transform: "translate(0.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10504",
    "data-name": "Path 10504",
    d: "M102.789,736.291l1.189,5.01,1.782-.01.065-5Z",
    transform: "translate(-92.807 -653.472)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10505",
    "data-name": "Path 10505",
    d: "M257.112,732.36l3.384,4.8,1.319-1.694-2.037-3.762Z",
    transform: "translate(-232.143 -649.326)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9391",
    "data-name": "Group 9391",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10506",
    "data-name": "Path 10506",
    d: "M16.753,64.756a8.087,8.087,0,0,0,.606-2.788,8.552,8.552,0,0,1-1,3.081c-2.959,1.943-8.631,8.43-8.519,9.659,0,0-.627-.588-1.535-1.423L6.1,72.023a2.493,2.493,0,0,0-.116.964c-1.7-1.556-4.134-3.751-5.437-4.742a15.749,15.749,0,0,1,.612-1.49c-.38.105-.831.8-1.05,1.173C.07,67.9.034,67.878,0,67.858c0,0,.388-3.062,4.8-5.349,2.314-1.2,3.9-1.7,3.808-3.216s.605-8.069,5.052-6.356a2.9,2.9,0,0,1,1.033-.27.873.873,0,0,0-.394.187,3.451,3.451,0,0,1,1.868.357c1.63.926,3.089,9.238.583,11.544",
    transform: "translate(0 -36.223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10507",
    "data-name": "Path 10507",
    d: "M127.74,140.559a4.1,4.1,0,0,1-2.515.459,3.262,3.262,0,0,1-1.675-1.606c.433-.086.557-.68.548-3.235l.2.039,3.288.651s-.075,1.035-.077,2.01c0,.818.047,1.595.235,1.682",
    transform: "translate(-111.552 -111.637)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10508",
    "data-name": "Path 10508",
    d: "M134.5,137.226s-.075,1.035-.077,2.009c-1.84-.052-2.812-1.73-3.211-2.66Z",
    transform: "translate(-118.47 -111.995)",
    fill: "#d68d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10509",
    "data-name": "Path 10509",
    d: "M116.335,70.078a9.669,9.669,0,0,1-1.2-2.826c-.165-.93.309-4.378,3.773-3.881a4.707,4.707,0,0,1,1.952.738c.752.508,1.838,1.6.624,4.613l-.315,1.016Z",
    transform: "translate(-103.933 -45.856)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10510",
    "data-name": "Path 10510",
    d: "M126.495,406.276l-1.743.053-1.887.058a37.239,37.239,0,0,1-6.8-12.629q-.086-.271-.181-.549c-1.338-3.9-4.111-8.8-5.572-13.228-.233-.706-.441-1.37-.629-2-.06-.2-.119-.4-.174-.594a47.006,47.006,0,0,1-1.676-8.824l10.553.085a196.713,196.713,0,0,0,8.111,37.628",
    transform: "translate(-97.359 -321.455)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10511",
    "data-name": "Path 10511",
    d: "M78.647,179.843c-.027,5.022.737,7.176.737,7.176a14.18,14.18,0,0,1-9.888.606c-.063-.02-4.039-.818-4.039-.818.09-.2,1.187-3.677,1.274-3.864a14.94,14.94,0,0,0,1.424-4.364,15.921,15.921,0,0,0,.131-4.207,33.76,33.76,0,0,0-1.3-6.607,34.331,34.331,0,0,0,4.356-1.489,3.4,3.4,0,0,0,2.35.872c1.07-.023,1.417-.481,1.361-.981,1.14.634,2.049,1.234,2.049,1.234.969,1.683,2.934,3.317,3.076,5.9.035.635-1.528,6.4-1.529,6.544",
    transform: "translate(-59.099 -138.713)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10512",
    "data-name": "Path 10512",
    d: "M174.146,172.383c-1.549-1.81-5.563-5.734-9.7-6.216l3.574,6.963a3.081,3.081,0,0,0,1.259,1.889,20.74,20.74,0,0,0,5.889,2.457,30.932,30.932,0,0,0,5.284-3.21,18.322,18.322,0,0,0,2.641-3.379l-.454-1.519s-2.857,1.6-3.878,2.058c-.582.263-1.921.89-2.865,1.333a1.472,1.472,0,0,1-1.745-.376",
    transform: "translate(-148.472 -138.713)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10513",
    "data-name": "Path 10513",
    d: "M130.44,84.49s-4.353.072-4.356-2.64-.567-4.529,2.212-4.689,3.32.874,3.542,1.779-.266,5.462-1.4,5.55",
    transform: "translate(-113.796 -58.336)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10514",
    "data-name": "Path 10514",
    d: "M117.266,71.507s-1.192,3.181-3.021,3.652a3.6,3.6,0,0,1-2.623-.02,5.18,5.18,0,0,0,1.694-3.06s3.05-2.086,3.949-.572",
    transform: "translate(-100.782 -52.748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10515",
    "data-name": "Path 10515",
    d: "M166.7,74.468a3.845,3.845,0,0,1,1.107,1.4c.217.691.315,2.112.729,2.064,0,0,.9-2.162-.111-3.385-1.07-1.3-1.725-.079-1.725-.079",
    transform: "translate(-150.507 -55.451)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10516",
    "data-name": "Path 10516",
    d: "M351.775,181.188a2.717,2.717,0,0,1,3.045-1.9c.279.087,1.094.413.573,1.285-.384.643-.551.311-1.155,1.176a1.925,1.925,0,0,1-2.01.957Z",
    transform: "translate(-317.613 -150.533)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10517",
    "data-name": "Path 10517",
    d: "M112.054,784.995a4.827,4.827,0,0,1-.227,2.054s-.292,1.329,1.017,1.353,1.63-.1,1.481-.913-.43-2.224-.43-2.224Z",
    transform: "translate(-100.942 -697.446)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10518",
    "data-name": "Path 10518",
    d: "M113.386,807.75s-.028.017-.082.044h-2.561a.633.633,0,0,1-.072-.044,6.43,6.43,0,0,1,.094-1.921c1.482,1.358,2.409-.034,2.409-.034a6.949,6.949,0,0,1,.213,1.955",
    transform: "translate(-99.88 -716.226)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10519",
    "data-name": "Path 10519",
    d: "M292.019,774.478a32.746,32.746,0,0,1-3.153-4.04l-1.794.919,4.01,3.766.938-.123Z",
    transform: "translate(-259.194 -684.302)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10520",
    "data-name": "Path 10520",
    d: "M289.289,784.414h-3.3a4.689,4.689,0,0,1-.984-1.526,1.618,1.618,0,0,0-1.092-.73v2.23h-.685l-.649-2.371a2.182,2.182,0,0,1,.267-2.117c.349,0,1.29.238,3.072,2.247a2.336,2.336,0,0,0,1.875.875.162.162,0,0,0,.026.014,2.393,2.393,0,0,1,1.471,1.378",
    transform: "translate(-254.967 -692.846)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10521",
    "data-name": "Path 10521",
    d: "M164.25,166.167s2.519,6.222,2.593,7.481.3,20.591.3,20.591-.148.889,1.555.518a5.721,5.721,0,0,0,2.148-.741s-1.63-11.925-1.185-16.073-3.407-10.913-3.407-10.913Z",
    transform: "translate(-148.299 -138.713)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10522",
    "data-name": "Path 10522",
    d: "M140.336,477.406l-1.887.058a37.239,37.239,0,0,1-6.8-12.629q-.085-.271-.181-.549c-1.338-3.9-4.111-8.8-5.572-13.228-.233-.706-.441-1.37-.629-2-.06-.2-.119-.4-.174-.594l1.554-1.179s4.666,7.555,6.11,14.665c1.255,6.176,6.28,13.607,7.58,15.455",
    transform: "translate(-112.944 -392.531)",
    fill: "#262d4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10523",
    "data-name": "Path 10523",
    d: "M67.622,443.971c.027,3.458-.148,11.407-.6,14.7H65.353c-.924,0-1.384-.013-1.384-.013-1.13-5.722-1.933-10.456-2.518-14.536-.48-3.348-.907-6.218-1.235-8.689-.33-2.487-.56-4.569-.642-6.328-.013-.277-.022-.547-.027-.808s-.007-.519,0-.767l9.118-.889c-.115,6.058-1.052,15.323-1.037,17.332",
    transform: "translate(-53.758 -373.89)",
    fill: "#262d4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10524",
    "data-name": "Path 10524",
    d: "M65.658,481.575c-.924,0-1.384-.013-1.384-.013-1.13-5.722-1.933-10.457-2.518-14.536-.48-3.348-.907-6.218-1.235-8.689-.33-2.487-.56-4.569-.642-6.328l3.346,1.968s-2.135.753-1.321,6.457,2.621,20.335,3.755,21.142",
    transform: "translate(-54.063 -396.796)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10525",
    "data-name": "Path 10525",
    d: "M47.16,195.049a2.714,2.714,0,0,1-2.864,2.024,26.783,26.783,0,0,1-5.382-1.63s.95-3,2.13-6.943c1.43-4.772,3.2-10.925,4.033-14.805a24,24,0,0,0,.453-2.646l1.844-3.577s2.749,6.169,2.9,7.725-3.111,19.851-3.111,19.851",
    transform: "translate(-35.135 -139.893)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10526",
    "data-name": "Path 10526",
    d: "M66.866,236.31c-.1,2.518-.692,7.407-5.975,10.024l-.042.02c1.43-4.772,3.2-10.925,4.033-14.805.97,1.45,2.038,3.375,1.984,4.761",
    transform: "translate(-54.94 -197.746)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10527",
    "data-name": "Path 10527",
    d: "M64.87,174.966l2.433-7.493a37.551,37.551,0,0,0-4.616,1.692,10.737,10.737,0,0,0-1.561,4.111s-.63,6.885.777,9.4c0,0,4.444.889,11.555-1.556v-1.63s-7.777.407-9.37.593Z",
    transform: "translate(-55.064 -139.893)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10528",
    "data-name": "Path 10528",
    d: "M65.107,167.473s-4.51.318-5.6,2.737-1.432,10.469-.049,12.839a12.59,12.59,0,0,0,5.27-.088l.124-.024s1.074-2.63.111-3.148c0,0-2.839.148-2.543-.79s2.683-11.527,2.683-11.527",
    transform: "translate(-52.867 -139.893)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10529",
    "data-name": "Path 10529",
    d: "M181.21,266.992a3.889,3.889,0,0,0,.752-1.518A1.65,1.65,0,0,1,183.573,264c1.069-.141,1.529-.156,1.526.146a7.981,7.981,0,0,1-2.408,3.663c-1.535,1.257-1.481-.815-1.481-.815",
    transform: "translate(-163.612 -226.957)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9385",
    "data-name": "Group 9385",
    transform: "translate(35.477 14.048)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9384",
    "data-name": "Group 9384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9383",
    "data-name": "Group 9383",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9382",
    "data-name": "Group 9382",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9381",
    "data-name": "Group 9381",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10530",
    "data-name": "Path 10530",
    d: "M386.714,30.257a13.175,13.175,0,0,0-3.956-2.131L365.321,42.058a13.1,13.1,0,0,0,.959,3.775c.081.186.162.37.249.553Z",
    transform: "translate(-365.323 -28.126)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9390",
    "data-name": "Group 9390",
    transform: "translate(37.983 17.925)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9389",
    "data-name": "Group 9389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9388",
    "data-name": "Group 9388",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9387",
    "data-name": "Group 9387",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9386",
    "data-name": "Group 9386",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10531",
    "data-name": "Path 10531",
    d: "M414.665,73.371a13.283,13.283,0,0,0-2.821-5.32L391.121,84.61a13.263,13.263,0,0,0,4.566,3.924l18.978-15.163",
    transform: "translate(-391.121 -68.051)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10532",
    "data-name": "Path 10532",
    d: "M.014,40.817a2.808,2.808,0,0,0,1.321,2.675,2.673,2.673,0,0,0,1.268.431,1.858,1.858,0,0,0,.962-.188l1.7-.839c1.133-.558,2.254-1.131,3.384-1.7s2.245-1.158,3.368-1.734,2.237-1.171,3.348-1.772Q18.7,35.9,22,34.026q1.648-.94,3.281-1.909a1.459,1.459,0,0,1,1.948.415,20.677,20.677,0,1,0-2.767-5.6,1.459,1.459,0,0,1-.855,1.8c-1.176.468-2.345.953-3.51,1.443q-3.495,1.476-6.944,3.043c-1.153.517-2.3,1.054-3.443,1.58-1.14.543-2.285,1.076-3.423,1.623S4.01,37.507,2.879,38.067l-1.7.834a1.854,1.854,0,0,0-.735.649,2.669,2.669,0,0,0-.43,1.269m51.377-5.5h0A16.314,16.314,0,0,1,29.541,27.9h0a16.315,16.315,0,1,1,21.851,7.41",
    transform: "translate(7.678 12.104) rotate(-9)",
    fill: "#040227"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreJobsMobile);
export default __webpack_public_path__ + "static/media/explore-jobs-mobile.5c303e504176d543e5f644c149d6c94c.svg";
export { ForwardRef as ReactComponent };